import React from 'react';
import Icon from 'components/lib/icons/icon';

export default props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M12.55 3.888a.604.604 0 010-.607L13.91.956C14.157.537 13.868 0 13.398 0H2.852C2.382 0 2 .398 2 .889V15.192c0 .447.347.808.774.808.427 0 .774-.361.774-.808V7.17h9.849c.47 0 .759-.538.514-.957L12.55 3.888z" />
  </Icon>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/flag_icon.jsx